export const PRODUCTS = [
  {
    slug: "piles-care",
    name: "Piles Care Capsule",
    tagline: "Natural Support for Healthy Digestive & Bowel Function",
    category: "Digestive Care",
    pack: "60 Capsules",
    price: 2399,
    mrp: 3199,
    image: "/products/p1_x4.png",
    gallery: ["/products/p1_x4.png", "/products/p2_x7.png", "/products/p3_x10.png", "/products/p4_x13.png"],
    benefits: [
      "Helps stop bleeding piles — supports fast relief from bleeding hemorrhoids",
      "Relieves pain, burning & uneasiness — soothes irritation and discomfort effectively",
      "Stops itching quickly — provides relief from anal itching and irritation",
      "Relief from constipation — promotes smooth and comfortable digestion",
      "Supports healthy digestion — helps maintain regular bowel movements",
      "Improves bowel function & gut health",
      "Natural & safe formula — gentle, effective care",
      "Safe & effective for long-term use",
    ],
    ingredients: [
      { name: "Haritaki", qty: "400 mg" },
      { name: "Neem", qty: "100 mg" },
      { name: "Behada", qty: "60 mg" },
      { name: "Triphala", qty: "60 mg" },
      { name: "Guggul", qty: "50 mg" },
      { name: "Amla", qty: "40 mg" },
      { name: "Shuddh Shilajit", qty: "30 mg" },
      { name: "Psyllium Husk", qty: "30 mg" },
      { name: "Nagkeshar", qty: "20 mg" },
      { name: "Other Herbal Extracts", qty: "10 mg" },
    ],
    dosage: "Adults: 1 or 2 capsules twice a day with warm water or milk, or as directed by your healthcare professional.",
  },
  {
    slug: "absolute-power",
    name: "Absolute Power for Men",
    tagline: "Improve Your Stamina — Stronger Stamina, Healthier You!",
    category: "Men's Wellness",
    pack: "60 Capsules",
    price: 2599,
    mrp: 3499,
    image: "/products/p5_x16.png",
    gallery: ["/products/p5_x16.png", "/products/p6_x19.png", "/products/p7_x22.png", "/products/p8_x25.png"],
    benefits: [
      "Increase male performance — boosts stamina, energy and endurance naturally",
      "Improve muscle strength — supports lean muscle growth, recovery and physical performance",
      "Reduce stress & fatigue — better mental and physical focus",
      "Boost testosterone level — supports healthy testosterone naturally",
      "Boosts energy levels — stay active and energetic throughout the day",
      "Supports digestive health — better nutrient absorption and a healthy gut",
      "Improves overall wellness — mood, mental clarity and physical well-being",
      "Natural herbal formula — ideal for adult men of all ages",
    ],
    ingredients: [
      { name: "Ashwagandha Ext.", qty: "" },
      { name: "Salop Ext.", qty: "" },
      { name: "Shilajit Ext.", qty: "" },
      { name: "Safed Musli Ext.", qty: "" },
      { name: "Vidarikand Ext.", qty: "" },
      { name: "Shatavari Ext.", qty: "" },
      { name: "Lauh Beej Ext.", qty: "" },
      { name: "Ginseng Ext.", qty: "" },
      { name: "Gokshura Ext.", qty: "" },
    ],
    dosage: "Adults: 1 or 2 capsules twice a day with warm water or milk, or as directed by your healthcare professional.",
  },
  {
    slug: "ortho",
    name: "Ortho Capsule",
    tagline: "Arthritic & Joint Pain Relief — Move Freely, Live Better!",
    category: "Joint & Bone Care",
    pack: "60 Capsules",
    price: 2499,
    mrp: 3299,
    image: "/products/p9_x28.png",
    gallery: ["/products/p9_x28.png", "/products/p10_x31.png", "/products/p11_x34.png", "/products/p12_x37.png"],
    benefits: [
      "Relieves joint pain — reduces pain, stiffness and inflammation",
      "Supports bone strength — maintains strong and healthy bones",
      "Promotes cartilage regeneration — natural repair of cartilage",
      "Improves joint flexibility & mobility — move freely and stay active",
      "Knee pain relief and back pain comfort",
      "Shoulder support and hand & wrist flexibility",
      "Natural herbal formula — no harmful chemicals",
      "Safe & effective — stronger joints, better tomorrow",
    ],
    ingredients: [
      { name: "Glucosamine", qty: "60 mg" },
      { name: "Ashwagandha Root Extract", qty: "50 mg" },
      { name: "Collagen", qty: "50 mg" },
      { name: "Boswellia Extract", qty: "40 mg" },
      { name: "Calcium", qty: "40 mg" },
      { name: "Curcumin", qty: "40 mg" },
      { name: "MSM", qty: "30 mg" },
      { name: "Amla Extract", qty: "20 mg" },
      { name: "Vitamin D3", qty: "10 mg" },
    ],
    dosage: "Take 2 capsules daily after meals, or as directed by your healthcare professional. For better results, use regularly.",
  },
  {
    slug: "diabetes",
    name: "Diabetes Capsule",
    tagline: "Natural Support for Healthy Blood Sugar Levels",
    category: "Sugar Care",
    pack: "60 Capsules",
    price: 2599,
    mrp: 3499,
    image: "/products/p13_x40.png",
    gallery: ["/products/p13_x40.png", "/products/p14_x43.png", "/products/p15_x46.png", "/products/diabetes_4.jpg"],
    benefits: [
      "Helps maintain healthy blood sugar levels within normal range",
      "Supports pancreatic health — natural insulin production",
      "Helps in metabolism & digestion",
      "Supports heart health — healthy cholesterol and blood circulation",
      "Boosts energy levels — stay active throughout the day",
      "Strengthens immunity — rich in antioxidants",
      "100% natural ingredients, no harmful chemicals",
      "Safe & effective for long-term use, suitable for adults of all ages",
    ],
    ingredients: [
      { name: "Proprietary blend of 100% natural Ayurvedic herbs", qty: "full list on pack" },
    ],
    dosage: "As directed by your healthcare professional.",
  },
  {
    slug: "play-more",
    name: "Play More — African Herbs",
    tagline: "Power of 25 Super Herbs — Only for Adult Men",
    category: "Men's Wellness",
    pack: "60 Capsules · 800 mg each",
    price: 1499,
    mrp: 1999,
    image: "/products/pm_1.png",
    gallery: ["/products/pm_1.png", "/products/pm_2.png", "/products/pm_3.png", "/products/pm_4.png"],
    benefits: [
      "Power of 25 super herbs in one capsule — premium herbal blend for men",
      "Wellness support for every part of your day — morning routine, active day, everyday wellness",
      "Herbal blend for men's daily wellness support",
      "Supports stamina, vitality and performance for adult men",
      "Boosts energy levels through the day",
      "Easy to add to your daily routine — convenient herbal wellness support",
      "Ayurvedic formula — 100% herbal, no harmful chemicals",
    ],
    ingredients: [
      { name: "Ashwagandha", qty: "" },
      { name: "Safed Musli", qty: "" },
      { name: "Shilajit", qty: "" },
      { name: "Kaunch Beej", qty: "" },
      { name: "Tribulus", qty: "" },
      { name: "25 Ayurvedic super herbs blend", qty: "full list on pack" },
    ],
    dosage: "Adults: 2 capsules a day with warm water or milk, or as directed by your healthcare professional.",
  },
  {
    slug: "xxx-josh",
    name: "XXX Josh",
    tagline: "Long-Lasting Stamina & Power — Premium 17 in 1",
    category: "Men's Wellness",
    pack: "60 Capsules · 800 mg each",
    price: 1499,
    mrp: 1999,
    image: "/products/josh_1.png",
    gallery: ["/products/josh_1.png", "/products/josh_2.png", "/products/josh_3.png", "/products/josh_4.png"],
    benefits: [
      "Long-lasting stamina & power — formulated for men's wellness and drive",
      "Energy & mood creation — stay active and positive",
      "Muscle recovery support after physical activity",
      "Fat loss & healthy BMI support",
      "Reviving romance & closeness",
      "Supports overall performance",
      "GMP, FDA, ISO certified — lab tested, 30 days supply",
    ],
    ingredients: [
      { name: "Tribulus Terrestris Extract", qty: "200 mg" },
      { name: "Panax Ginseng Extract", qty: "150 mg" },
      { name: "Ashwagandha Extract", qty: "150 mg" },
      { name: "Safed Musli Extract", qty: "150 mg" },
      { name: "L-Arginine", qty: "150 mg" },
      { name: "Maca Root Extract", qty: "100 mg" },
      { name: "Tongkat Ali Extract", qty: "100 mg" },
      { name: "Kaunch Beej", qty: "100 mg" },
      { name: "Shilajit Extract", qty: "100 mg" },
      { name: "L-Citrulline", qty: "100 mg" },
      { name: "L-Carnitine", qty: "100 mg" },
      { name: "Fenugreek Seed Extract", qty: "50 mg" },
      { name: "Mucuna Pruriens", qty: "50 mg" },
      { name: "Grapeseed Extract", qty: "50 mg" },
      { name: "Ginkgo Biloba Extract", qty: "50 mg" },
      { name: "Gokshura Extract", qty: "50 mg" },
      { name: "Pomegranate Extract", qty: "50 mg" },
    ],
    dosage: "Adults: 2 capsules a day with warm water or milk, or as directed by your healthcare professional.",
  },
  {
    slug: "height-veda",
    name: "Height Veda Plus",
    tagline: "Nutrition Powder for Growing Teens & Adults — Advanced Daily Wellness Formula",
    category: "Height & Growth",
    pack: "400 GM · Chocolate Flavour",
    price: 999,
    mrp: 1399,
    image: "/products/hv_1.png",
    gallery: ["/products/hv_1.png", "/products/hv_2.png", "/products/hv_3.png", "/products/hv_4.png"],
    benefits: [
      "20 nutritional ingredients — a potent, full-spectrum blend for optimal growth",
      "Calcium + Vitamin D3 + K2 — enhanced bone mineral density and strength",
      "Collagen & amino acids — vital for growth of bones, cartilage and connective tissues",
      "Delicious chocolate flavour that teens and adults enjoy",
      "Teen & adult support — specifically formulated for individuals aged 12–30+",
      "Daily wellness nutrition — comprehensive supplement for overall health and vitality",
      "Bone health support with daily nutrition for growing teens and adults",
    ],
    ingredients: [
      { name: "Guduchi (Tinospora Cordifolia)", qty: "" },
      { name: "Shatavari (Asparagus Racemosus)", qty: "" },
      { name: "Ashwagandha", qty: "" },
      { name: "Hadjod (Cissus Quadrangularis)", qty: "" },
      { name: "Amla (Emblica Officinalis)", qty: "" },
      { name: "Collagen & Amino Acids", qty: "" },
      { name: "Calcium Citrate", qty: "" },
      { name: "Magnesium", qty: "" },
      { name: "Zinc", qty: "" },
      { name: "L-Lysine", qty: "" },
      { name: "Taurine", qty: "" },
      { name: "Vitamin D3", qty: "" },
      { name: "Vitamin K2 (MK-7)", qty: "" },
    ],
    dosage: "Mix the recommended scoop in warm milk or water daily, as directed on the pack or by your healthcare professional. Formulated for individuals aged 12–30+.",
  },
  {
    slug: "sukoon-nights",
    name: "Sukoon Nights",
    tagline: "25 Premium Herbal Formula — Restful Nights & Overall Vitality",
    category: "Men's Wellness",
    pack: "60 Capsules · 800 mg each",
    price: 1399,
    mrp: 1899,
    image: "/products/sn_1.png",
    gallery: ["/products/sn_1.png", "/products/sn_2.png", "/products/sn_3.png", "/products/sn_4.png"],
    benefits: [
      "Premium 25-in-1 herbal formula with African herbs",
      "Restful nights & overall vitality",
      "Supports overall vitality — premium herbal formula for modern lifestyle",
      "Boosts stamina and drive for men",
      "Helps reduce stress and fatigue for better performance",
      "800 mg per capsule — 60 capsules, full 30-day supply",
      "An Ayurvedic proprietary medicine — crafted with premium standards",
    ],
    ingredients: [
      { name: "Ashwagandha", qty: "" },
      { name: "Tribulus Terrestris", qty: "" },
      { name: "Safed Musli", qty: "" },
      { name: "Kaunch Beej", qty: "" },
      { name: "25 premium herbal blend (African herbs formula)", qty: "full list on pack" },
    ],
    dosage: "Adults: 2 capsules a day with warm water or milk, or as directed by your healthcare professional.",
  },
];

export const TESTIMONIALS = [
  { name: "Ramesh Gupta", city: "Jaipur", product: "Piles Care Capsule", rating: 5, text: "Bleeding stopped within two weeks of regular use. After trying so many things, this Ayurvedic capsule finally gave me real relief. No side effects at all." },
  { name: "Sunita Sharma", city: "Delhi", product: "Ortho Capsule", rating: 5, text: "My knee pain made climbing stairs impossible. Two months on Ortho and I walk every morning now. Joints feel lighter and movement is much easier." },
  { name: "Vikram Singh", city: "Mumbai", product: "Absolute Power", rating: 5, text: "Energy levels are completely different now. I feel active through the whole day and my gym performance has genuinely improved. Pure herbs, no chemicals." },
  { name: "Anil Verma", city: "Lucknow", product: "Diabetes Capsule", rating: 4, text: "My sugar readings have become much more stable along with my regular routine. I feel less tired in the afternoons. Good natural support." },
  { name: "Priya Nair", city: "Bengaluru", product: "Ortho Capsule", rating: 5, text: "Bought this for my mother's shoulder pain. She says the stiffness has reduced a lot and she can do her daily work comfortably again." },
  { name: "Rajesh Kumar", city: "Pune", product: "Piles Care Capsule", rating: 4, text: "The burning and itching reduced in the first week itself. Constipation is also much better. Very satisfied with a fully herbal product." },
  { name: "Mohan Lal", city: "Indore", product: "Absolute Power", rating: 5, text: "At 45 I was feeling drained all the time. Absolute Power brought back my stamina and focus. The herbal formula really works." },
  { name: "Kavita Joshi", city: "Ahmedabad", product: "Diabetes Capsule", rating: 5, text: "Trusted it because of the ISO and FSSAI certifications. Three months in, my energy is better and digestion has improved noticeably." },
  { name: "Sanjay Yadav", city: "Patna", product: "XXX Josh", rating: 4, text: "Noticeable improvement in stamina and confidence. Delivery was quick and the packaging is premium. Will reorder." },
  { name: "Deepak Chouhan", city: "Bhopal", product: "Play More", rating: 5, text: "Excellent herbal blend. I feel a clear difference in drive and energy within a few weeks. No jitters like chemical supplements." },
  { name: "Arun Mehta", city: "Surat", product: "Piles Care Capsule", rating: 5, text: "I was scared of surgery. This capsule controlled my bleeding piles and my digestion is regular now. Grateful for this product." },
  { name: "Farhan Ali", city: "Hyderabad", product: "Absolute Power", rating: 4, text: "Good quality supplement. Stress and fatigue are much lower and recovery after workouts is faster. Value for money." },
];

export const CERTIFICATES = [
  {
    title: "ISO 9001:2015",
    subtitle: "Quality Management System",
    issuer: "QRO Certification",
    image: "/certificates/emb_p1_x4.png",
  },
  {
    title: "WHO-GMP",
    subtitle: "Good Manufacturing Practice",
    issuer: "UK Certification & Inspection",
    image: "/certificates/emb_p2_x7.png",
  },
  {
    title: "ISO 22000:2018",
    subtitle: "Food Safety Management Systems",
    issuer: "QRO Certification",
    image: "/certificates/emb_p3_x10.png",
  },
  {
    title: "FSSAI Central License",
    subtitle: "License No. 12222999000568",
    issuer: "Food Safety and Standards Authority of India",
    image: "/certificates/emb_p4_x13.png",
  },
];

export const BANNERS = [
  {
    image: "/products/hero_diabetes.jpg",
    overline: "Sugar Care",
    title: "Control Your Sugar Naturally.",
    subtitle: "Diabetes Capsule — natural support for healthy blood sugar, metabolism and energy.",
    slug: "diabetes",
    cta: "Shop Diabetes Care",
  },
  {
    image: "/products/hero_ortho.jpg",
    overline: "Joint & Bone Care",
    title: "Move Freely. Live Better.",
    subtitle: "Ortho Capsule — Ayurvedic relief for joint pain, stiffness and stronger bones.",
    slug: "ortho",
    cta: "Shop Ortho",
  },
  {
    image: "/products/hero_absolute.jpg",
    overline: "Men's Wellness",
    title: "Stronger Stamina. Healthier You.",
    subtitle: "Absolute Power for Men — a premium herbal blend for stamina, strength and vitality.",
    slug: "absolute-power",
    cta: "Shop Absolute Power",
  },
  {
    image: "/products/hero_piles.jpg",
    overline: "Digestive Care",
    title: "Live Better. Feel Lighter Every Day.",
    subtitle: "Piles Care Capsule — herbal relief from bleeding piles, pain, burning and constipation.",
    slug: "piles-care",
    cta: "Shop Piles Care",
  },
];

export const HERB_IMG_FALLBACK =
  "https://images.pexels.com/photos/33410911/pexels-photo-33410911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const HERBS = [
  {
    name: "Ashwagandha",
    benefit: "Strength, stamina & stress relief",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/24/Withania_somnifera_1DS-II_3-7489.jpg/960px-Withania_somnifera_1DS-II_3-7489.jpg",
    story: "Known as the 'King of Rasayanas' in Ayurveda, Ashwagandha (Withania somnifera) has been used for over 3,000 years as a powerful adaptogen. It calms the nervous system, lowers stress, builds physical strength and stamina, and supports restful sleep. Classical texts praise it for restoring vitality in those weakened by stress, age or illness.",
    foundIn: ["Absolute Power for Men", "Ortho Capsule"],
  },
  {
    name: "Shilajit",
    benefit: "Energy, vitality & testosterone support",
    image: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Shilajit-1_%281%29.jpg",
    story: "Shilajit is a mineral-rich resin that seeps from Himalayan rocks, formed over centuries from decomposed plant matter. Rich in fulvic acid and 80+ trace minerals, Ayurveda calls it 'the destroyer of weakness' — it fuels cellular energy, supports healthy testosterone, sharpens the mind and slows the effects of ageing.",
    foundIn: ["Absolute Power for Men", "Piles Care Capsule"],
  },
  {
    name: "Safed Musli",
    benefit: "Male performance & endurance",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7f/Chlorophytum_borivilianum_%284695984110%29.jpg/960px-Chlorophytum_borivilianum_%284695984110%29.jpg",
    story: "Safed Musli (Chlorophytum borivilianum) is one of Ayurveda's most valued rasayana herbs for male wellness. Traditionally cultivated in the forests of central India, its roots are prized for building endurance, supporting healthy performance and restoring vigour — earning it the title 'white gold' of Ayurvedic herbs.",
    foundIn: ["Absolute Power for Men"],
  },
  {
    name: "Gokshura",
    benefit: "Vitality & urinary health",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/2d/Tribulus_terrestris_-_Dghoumes_National_Park.jpg/960px-Tribulus_terrestris_-_Dghoumes_National_Park.jpg",
    story: "Gokshura (Tribulus terrestris) is a classical Ayurvedic herb for strength and vitality. It supports the urinary tract and kidneys, aids muscle building and recovery, and is traditionally recommended for men's reproductive health. Modern studies support its role in maintaining healthy energy and drive.",
    foundIn: ["Absolute Power for Men"],
  },
  {
    name: "Shatavari",
    benefit: "Hormonal balance & rejuvenation",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c4/Asparagus_racemosus_0741.jpg/960px-Asparagus_racemosus_0741.jpg",
    story: "Shatavari (Asparagus racemosus) means 'the one with a hundred roots' — a symbol of its deep nourishing power. A cooling rasayana, it balances hormones, soothes the digestive system and builds long-term vitality. While famous for women's health, classical texts value it equally for male rejuvenation and strength.",
    foundIn: ["Absolute Power for Men"],
  },
  {
    name: "Ginseng",
    benefit: "Focus, energy & fatigue reduction",
    image: "https://upload.wikimedia.org/wikipedia/commons/2/25/American_Ginseng_1.jpg",
    story: "Ginseng (Panax) is one of the world's most researched vitality roots, treasured across Asian medicine for over 2,000 years. Its ginsenosides fight fatigue, sharpen focus and memory, and strengthen immunity. Blended with Ayurvedic rasayanas, it provides steady, jitter-free energy through the day.",
    foundIn: ["Absolute Power for Men"],
  },
  {
    name: "Haritaki",
    benefit: "Digestion & bowel regularity",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7e/Haritaki_%28Terminalia_chebula%29_fruits.jpg/960px-Haritaki_%28Terminalia_chebula%29_fruits.jpg",
    story: "Haritaki (Terminalia chebula) is called the 'King of Medicines' in Tibetan and Ayurvedic tradition. At 400 mg — the lead ingredient in Piles Care — it gently regulates bowel movement, clears accumulated toxins and strengthens digestion. Classical healers held it so highly that it is said 'even a mother can sometimes be harsh, but Haritaki never is.'",
    foundIn: ["Piles Care Capsule"],
  },
  {
    name: "Triphala",
    benefit: "Gut health & gentle detox",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/52/Bahera_%28Terminalia_bellirica%29_fruits.jpg/960px-Bahera_%28Terminalia_bellirica%29_fruits.jpg",
    story: "Triphala — the legendary blend of Amla, Haritaki and Bibhitaki — is Ayurveda's most trusted formula for gut health. Used daily for over 2,000 years, it cleanses the colon without harsh purging, improves nutrient absorption and relieves constipation, making it a cornerstone of piles and digestive care.",
    foundIn: ["Piles Care Capsule"],
  },
  {
    name: "Guggul",
    benefit: "Joint comfort & metabolism",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f9/Commiphora_wightii_AK18.jpg/960px-Commiphora_wightii_AK18.jpg",
    story: "Guggul is the aromatic resin of the Commiphora wightii tree from the dry regions of Rajasthan and Gujarat. Ayurveda uses it to pacify vata in the joints, scrape away toxins (ama) and kindle metabolism. Modern research confirms its guggulsterones support healthy cholesterol and a balanced inflammatory response.",
    foundIn: ["Piles Care Capsule"],
  },
  {
    name: "Neem",
    benefit: "Purification & gut wellness",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/45/Azadirachta_indica%2C_leaves_%26_fruits.JPG/960px-Azadirachta_indica%2C_leaves_%26_fruits.JPG",
    story: "Neem (Azadirachta indica) is India's 'village pharmacy' — every part of the tree is medicinal. Its bitter leaves purify the blood, cool inflammation and keep the gut free of harmful microbes. In piles care, neem's soothing and cleansing action helps calm irritated tissues and supports healing.",
    foundIn: ["Piles Care Capsule"],
  },
  {
    name: "Amla",
    benefit: "Immunity & antioxidant power",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/41/Gooseberry_%28_Phyllanthus_emblica%29.jpg/960px-Gooseberry_%28_Phyllanthus_emblica%29.jpg",
    story: "Amla (Phyllanthus emblica), the Indian gooseberry, is one of nature's richest sources of stable Vitamin C. A premier rasayana, it rebuilds immunity, cools excess heat (pitta), strengthens digestion and nourishes every tissue. It is the foundation of Triphala and of countless classical rejuvenative formulas.",
    foundIn: ["Piles Care Capsule", "Ortho Capsule"],
  },
  {
    name: "Nagkeshar",
    benefit: "Traditional piles relief",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5b/Mesua_ferrea_flower.jpg/960px-Mesua_ferrea_flower.jpg",
    story: "Nagkeshar (Mesua ferrea) is a fragrant golden flower with a special place in Ayurvedic management of bleeding disorders. Classical texts prescribe it specifically for bleeding piles — it constricts and strengthens blood vessels, cools inflammation and supports the healing of delicate rectal tissues.",
    foundIn: ["Piles Care Capsule"],
  },
  {
    name: "Curcumin",
    benefit: "Anti-inflammatory joint support",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5b/Curcuma_longa_roots.jpg/960px-Curcuma_longa_roots.jpg",
    story: "Curcumin is the golden active compound of turmeric (Curcuma longa), Ayurveda's most celebrated anti-inflammatory herb. It calms joint inflammation, protects cartilage from wear and fights oxidative stress. In Ortho Capsule it works alongside Boswellia and Ashwagandha for complete joint comfort.",
    foundIn: ["Ortho Capsule"],
  },
  {
    name: "Boswellia",
    benefit: "Cartilage & mobility care",
    image: "https://upload.wikimedia.org/wikipedia/commons/b/bf/Boswellia_serrata_%28Salai%29_in_Kinnarsani_WS%2C_AP_W2_IMG_5840.jpg",
    story: "Boswellia (Shallaki), the frankincense tree of India, yields a resin that Ayurveda has used for centuries against joint pain and stiffness. Its boswellic acids protect cartilage, improve blood supply to joints and restore free movement — modern clinical studies rank it among the best natural options for arthritis care.",
    foundIn: ["Ortho Capsule"],
  },
  {
    name: "Vidarikand",
    benefit: "Strength & rejuvenation",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/41/Pueraria_tuberosa_%28Roxb._ex_Willd.%29_DC._%286926236863%29.jpg/960px-Pueraria_tuberosa_%28Roxb._ex_Willd.%29_DC._%286926236863%29.jpg",
    story: "Vidarikand (Pueraria tuberosa) is a sweet, heavy rasayana tuber from the Himalayan foothills. It nourishes and builds body tissues, supports healthy testosterone and reproductive vitality, and cools the system — classical texts count it among the finest herbs for rebuilding strength after depletion.",
    foundIn: ["Absolute Power for Men"],
  },
  {
    name: "Psyllium Husk",
    benefit: "Smooth, comfortable digestion",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/0b/Plantago_ovata_form.jpg/960px-Plantago_ovata_form.jpg",
    story: "Psyllium (Isabgol, Plantago ovata) is a gentle soluble fibre cultivated mainly in Gujarat and Rajasthan. It absorbs water to soften stools, eases passage without straining — critical for piles relief — and feeds beneficial gut bacteria. It makes bowel movement smooth, regular and comfortable.",
    foundIn: ["Piles Care Capsule"],
  },
  {
    name: "Glucosamine + MSM",
    benefit: "Bone & joint nourishment",
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/33/Boswellia_sacra.jpg/960px-Boswellia_sacra.jpg",
    story: "Glucosamine and MSM are the modern nutraceutical partners of Ayurveda's joint herbs. Glucosamine is the raw building block your body uses to repair cartilage, while MSM supplies organic sulphur for flexible, strong connective tissue. Together with Collagen, Calcium and Vitamin D3 in Ortho Capsule, they rebuild joints from within.",
    foundIn: ["Ortho Capsule"],
  },
];

export const VIDEO_BANNER = {
  video: "/video/brand-video.mp4",
  poster: "/products/p7_x22.png",
  overline: "Eleven Stars",
  title: "Wellness for Life",
  subtitle: "Watch our story — pure Ayurvedic wellness, crafted in Jaipur, shipped across India.",
  slug: null,
  cta: "Explore Products",
};

export const WHATSAPP_NUMBER = "918081828348";
export const WHATSAPP_DISPLAY = "+91 80818 28348";
export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const formatINR = (n) => "₹" + n.toLocaleString("en-IN");
